function getDaySuffix(day) {
    if (day > 3 && day < 21) return 'th'; // 4th to 20th
    switch (day % 10) {
        case 1: return 'st';
        case 2: return 'nd';
        case 3: return 'rd';
        default: return 'th';
    }
}
function formatDate(date) {
    const monthNames = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"];
    const day = date.getDate();
    const month = monthNames[date.getMonth()];
    const daySuffix = getDaySuffix(day);
    return `${month} ${day}${daySuffix}`;
}
function getThirdMonday(month) {
    const year = new Date().getFullYear();
    const d = new Date(year, month - 1, 1);
    d.setDate(1 + ((7 - d.getDay() + 1) % 7) + 14);
    return `${month}-${String(d.getDate()).padStart(2, '0')}`;
}
function getLastMonday(month) {
    const year = new Date().getFullYear();
    const d = new Date(year, month, 0);
    d.setDate(d.getDate() - ((d.getDay() + 6) % 7));
    return `${month}-${String(d.getDate()).padStart(2, '0')}`;
}
function getFirstMonday(month) {
    const year = new Date().getFullYear();
    const d = new Date(year, month - 1, 1);
    d.setDate(1 + ((7 - d.getDay()) % 7));
    return `${month}-${String(d.getDate()).padStart(2, '0')}`;
}
function getSecondMonday(month) {
    const year = new Date().getFullYear();
    const d = new Date(year, month - 1, 1);
    d.setDate(1 + ((7 - d.getDay() + 1) % 7) + 7);
    return `${month}-${String(d.getDate()).padStart(2, '0')}`;
}
function getThanksgivingDay(month) {
    const year = new Date().getFullYear();
    const d = new Date(year, month - 1, 1);
    d.setDate(1 + ((7 - d.getDay() + 4) % 7) + 21);
    return `${month}-${String(d.getDate()).padStart(2, '0')}`;
}
function displayCurrentDate() {
    const nowDate = new Date();
    const formattedDate = formatDate(nowDate);
    const [month, day] = formattedDate.split(' ');
    document.getElementById('orderDate').innerText = `${month} ${day} `;
}
function calculateDeliveryDate() {
    const nowDate = new Date();
    const orderDate = new Date(nowDate);
    let businessDaysRemaining = 5;

    const holidays = [
        '01-01',//New Year's Day
        getThirdMonday('01'),//Martin Luther King Jr. Day
        getThirdMonday('02'),//Presidents' Day
        getLastMonday('05'),//Memorial Day
        '07-04',//Independence Day
        getFirstMonday('09'),//Labor Day
        getSecondMonday('10'),//Columbus Day
        '11-11',//Veterans Day
        getThanksgivingDay('11'),//Thanksgiving Day
        '12-25', //Christmas Day
    ];

    while (businessDaysRemaining > 0) {
        orderDate.setDate(orderDate.getDate() + 1);
        const dayOfWeek = orderDate.getDay();
        const month = String(orderDate.getMonth() + 1).padStart(2, '0');
        const day = String(orderDate.getDate()).padStart(2, '0');
        const formattedOrderDate = `${month}-${day}`;
        if (dayOfWeek !== 6 && dayOfWeek !== 0) { // Exclude Saturday (6) and Sunday (0)
            if (!holidays.includes(formattedOrderDate)) {// Exclude Holidays
                businessDaysRemaining -= 1;
            }
        }
    }

    const formattedDate = formatDate(orderDate);
    const [month, day] = formattedDate.split(' ');
    document.getElementById('shippingDate').innerText = ` ${month} ${day}`;
}
document.addEventListener('DOMContentLoaded', () => {
    displayCurrentDate();
    calculateDeliveryDate();
});